module.exports = __webpack_public_path__ + "static/media/rankTop.69698696.svg";